import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { Hub } from 'aws-amplify/utils';
import { Toast } from 'primeng/toast';
import { ConfirmationDialogComponent } from './core/component/confirmation-dialog/confirmation-dialog.component';
import { LoaderComponent } from './core/component/loader/loader.component';
import { AuthActions } from './shared/store/auth/auth.actions';
import { AuthSelectors } from './shared/store/auth/auth.selectors';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmationDialogComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'Concierge';

  private store: Store = inject(Store);
  constructor() {
    const token = this.store.selectSnapshot(AuthSelectors.token);

    if (token) {
      this.store.dispatch(new AuthActions.GetCurrentLogged());
    }

    Hub.listen('auth', async ({ payload }) => {
      switch (payload.event) {
        case 'signInWithRedirect':
          this.store.dispatch(new AuthActions.ConfirmSocialLogin());
          break;

        case 'signedOut':
          break;
      }
    });
  }
}
